import { createContext, useContext, useState, useEffect, useCallback } from "react";
import portalApi from "../lib/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(() => {
    const token = localStorage.getItem("portal_token");
    const userData = localStorage.getItem("portal_user");
    if (token && userData) {
      try { setUser(JSON.parse(userData)); }
      catch { localStorage.removeItem("portal_token"); localStorage.removeItem("portal_user"); }
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password, portalType = "customer") => {
    const endpoint = portalType === "vendor" ? "/portal/vendor/login" : "/portal/customer/login";
    const res = await portalApi.post(endpoint, { email, password });
    const userData = { ...res.data.user, portal_type: portalType };
    localStorage.setItem("portal_token", res.data.token);
    localStorage.setItem("portal_user", JSON.stringify(userData));
    setUser(userData);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("portal_token");
    localStorage.removeItem("portal_user");
    setUser(null);
  };

  return (
    <PortalAuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used within PortalAuthProvider");
  return ctx;
}
